import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Output } from '@angular/core';
import { Router } from '@angular/router';
import { API_PATH } from '@constant/api-path.constant';
import { PATH } from '@constant/path.constant';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import {
  CategoryData,
  GetCategoryService,
} from '@shared/service/api/get-category/get-category.service';
import { PageStateService } from '@shared/service/page-state.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, LoadingComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  private getCategoryService = inject(GetCategoryService);
  private pageStateService = inject(PageStateService);
  private router = inject(Router);
  protected categoryList: { catType: CategoryData }[] = [];
  protected isApiLoading = false;
  protected isShowMenu = true;
  @Output() toggleEmitter = new EventEmitter();

  constructor() {
    this.isApiLoading = true;
    this.getCategoryService
      .getCategoryApi(API_PATH.getCategory, null)
      .subscribe((data) => {
        this.categoryList = data.catTypeList;
        this.isApiLoading = false;
      });
  }

  changeCategory(category: string) {
    this.router.navigate([`${PATH.petList(category)}`]);
    this.pageStateService.page = 1;
    this.toggleEmitter.emit('changeCategory');
  }

  menuToggle() {
    this.toggleEmitter.emit('menuToggle');
  }
}
